// Mensagem de incentivo por dia da semana (0=domingo … 6=sábado), na voz do
// professor. Espelha `home/hero-welcome.jsx` (aluno), mas a pauta aqui é turma,
// correção e planejamento — não "estudar".
const WEEKDAY_MESSAGES = [
  'Domingo tranquilo — se der vontade de adiantar, o plano de aula da semana te espera. 🌤️',
  'Semana nova! Suas turmas começam por aqui. 💪',
  'Terça é um bom dia pra ver quem ficou pra trás nas atividades. 🎯',
  'Já é quarta! Que tal uma olhada no desempenho das suas turmas? 🔥',
  'Quinta produtiva — as correções pendentes agradecem. ⚡',
  'Sextou! Fecha a semana com o plano de aula no lugar. 🎉',
  'Sábado leve — dá uma espiada nos relatórios sem pressa. 😎'
];

// Saudação completa do personagem: nome + pauta do dia.
export function greetingForTeacher(day, firstName) {
  const hi = firstName ? `Olá, ${firstName}! 👋` : 'Olá! 👋';
  return `${hi} ${WEEKDAY_MESSAGES[day] ?? WEEKDAY_MESSAGES[1]}`;
}
